import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rezervator-cms/rezervator-cms/src/app/auth/login/_components/LoginForm.tsx");
